<template>
  <div class="container"
       style>
    <!-- 主体内容 -->
    <Boyo-Content ref="BoyoContent"
                  :visible="filterInfo.visible"
                  style="height:97%">
      <BoyoButton :buttonList="buttonList"
                  @handClick="handClick">
      </BoyoButton>
      <div>
        <Boyo-Form :formInfo="formInfoDetailCus"
                    :refObj.sync="formInfoDetailCus.ref"
                    :listTypeInfo='listTypeInfo'>
        </Boyo-Form>
        <div style="position:absolute;right:15px;top:50px">
          <p>营业执照</p>
          <el-upload
            class="avatar-uploader"
            :action="action"
            disabled
            :show-file-list="false">
            <img v-if="formInfoDetailCus.data.businessLicense" :src="formInfoDetailCus.data.businessLicense" class="avatar"
            @click="handlePictureCardPreview(formInfoDetailCus.data.businessLicense)">
            <i v-else class="el-icon-plus avatar-uploader-icon">
            </i>
          </el-upload>
        </div>
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick" style="margin-top:10px">
          <el-tab-pane label="往来单位常用联系人" name="2">
            <el-table :data="tableData2"
                      border
                       max-height="270px"
                      style="width: 100%;margin-bottom:15px"
                      :header-cell-style="{background:'#eff3f8',color:'#3C3C3C',padding:'4px 0'}"
                      :cell-style="{padding:'2px'}"
                      @row-click="rowClick">
                 <el-table-column type="index" label="序号" align='center'
                                width="60">
                </el-table-column>
                <el-table-column prop="contactName" align='center'
                                label="联系人">
                </el-table-column>
                <el-table-column prop="contactPhone" align='center'
                                label="联系电话">
                </el-table-column>
                <el-table-column prop="contactAddress" align='center'
                                label="联系地址">
                </el-table-column>
                <el-table-column prop="wxUserRole" align='center'
                                label="小程序角色">
                    <template slot-scope="scope">
                      <span v-if="scope.row.wxUserRole == 0">普通用户</span>
                      <span v-if="scope.row.wxUserRole == 2">审批管理员</span>
                      <span v-if="scope.row.wxUserRole == 3">现场人员</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                  fixed="right"
                  label="操作"
                  width="120">
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="deleteRow(scope.row, tableData2)"
                      type="text"
                      size="small">
                      删除
                    </el-button>
                  </template>
                </el-table-column> -->
            </el-table>
            <!-- <Boyo-Form :formInfo="formInfo2"
                        :refObj.sync="formInfo2.ref"
                        :listTypeInfo='listTypeInfo'>
            </Boyo-Form> -->
          </el-tab-pane>
          <el-tab-pane label="往来单位运输车辆" name="4">
            <el-table :data="tableData4"
                      border
                      max-height="270px"
                      style="width: 100%;margin-bottom:15px"
                      :header-cell-style="{background:'#eff3f8',color:'#3C3C3C',padding:'4px 0'}"
                      :cell-style="{padding:'2px'}"
                      @row-click="rowClick">
                <el-table-column type="index" label="序号" align='center'
                                width="60">
                </el-table-column>
                <el-table-column prop="carNo" align='center'
                                label="车辆编号">
                </el-table-column>
                <el-table-column prop="carDriver" align='center'
                                label="车主名称">
                </el-table-column>
                <el-table-column prop="carPhone" align='center'
                                label="车主电话">
                </el-table-column>
                <el-table-column prop="carType" align='center'
                                label="车辆类型">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.carType" style="width:80px" disabled>
                          <el-option v-for="item in listTypeInfo.carType"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                          </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="carAddress" align='center'
                                label="车辆地址">
                </el-table-column>
            </el-table>
            <!-- <Boyo-Form :formInfo="formInfo4"
                        :refObj.sync="formInfo4.ref"
                        :listTypeInfo='listTypeInfo'>
            </Boyo-Form> -->
          </el-tab-pane>
          <el-tab-pane label="往来单位常用地址" name="5">
            <el-table :data="tableData5"
                      border
                      max-height="270px"
                      style="width: 100%;margin-bottom:15px"
                      :header-cell-style="{background:'#eff3f8',color:'#3C3C3C',padding:'4px 0'}"
                      :cell-style="{padding:'2px'}"
                      @row-click="rowClick">
                <el-table-column type="index" label="序号" align='center'
                                width="60">
                </el-table-column>
                <el-table-column prop="receiveName" align='center'
                                label="收货人">
                </el-table-column>
                <el-table-column prop="receivePhone" align='center'
                                label="收货人电话">
                </el-table-column>
                <el-table-column prop="receiveAddress" align='center'
                                label="常用收地址">
                </el-table-column>
                <el-table-column prop="receiveRemark" align='center'
                                label="备注">
                </el-table-column>
            </el-table>
            <!-- <Boyo-Form :formInfo="formInfo5"
                        :refObj.sync="formInfo5.ref"
                        :listTypeInfo='listTypeInfo'>
            </Boyo-Form> -->
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </Boyo-Content>
  </div>
</template>

<script>
import BoyoContent from "@/components/BoyoContent";
import BoyoButton from "@/components/BoyoButton";
import BoyoTable from "@/components/BoyoTable";
import BoyoForm from "@/components/BoyoFormthree";
import BoyoDialog from '@/components/BoyoDialog'
import { rule } from "@/utils/rules";
import { excel } from '@/utils/excel'
import config from '@/api/config'
import * as imageConversion from 'image-conversion'
export default {
  name: "CusInformation",
  components: {
    BoyoContent,
    BoyoButton,
    BoyoForm,
    BoyoTable,
    BoyoDialog,
  },
  props: {},
  data () {
    return {
      action: config.upload,
      imgUrl:config.pingImgUrl,
      search: {},
      add2:0,
      activeName: '2',
      dialogImageUrl: '',//弹框图片
      dialogVisible: false,
      tableData2:[],
      tableData4:[],
      tableData5:[],
      // 搜索相关
      filterInfo: {
        visible: null, // 是否显示
        data: {
          employeeName: '',
          deptId:'',
          pageNum:1,
          pageSize:100
        },
        list: [
          { type: "text", label: "员工名称：", value: "employeeName" },
          { type: "select", label: "部门：", value: "deptId",list:'deptId' }
        ]
      },
      // 下拉框相关信息
      listTypeInfo: {
        tissueId:[],//组织
        partnerId:[],//往来单位（客户）
        carType:[{value:0,label:'白名单'},{value:1,label:'黑名单'}],//车辆类型
        materialId:[],//物料
        auditStatus:[{value:0,label:'未审核'},{value:1,label:'已审核'}],
        validStatus:[{value:0,label:'未生效'},{value:1,label:'生效'}],
        unitActionList: [],
        areaList: [],
        partnerType:[{value:0,label:'客户'}, {value: 1, label: '供应商'}, {value: 2, label: '都是'}],
        tFlag:[{value:0,label:'可用'}, {value: 1, label: '停用'}],
      },
      // 表格头部按钮相关
      buttonList: {
        // 左按钮
        left: [
          // { icon: 'el-icon-download', style: 'background:#f8ac59', desc: '导出', event: 'excel' }
        ],
        right: []
      },
      //客户信息
      formInfoDetailCus: {
        ref: null,
        labelWidth: "30%",
        inline: true,
        data: {
          // id:'',
          // partnerId: localStorage.partnerId,
          partnerArea:'',
          partnerGroup:'',
          partnerCode:'',
          partnerName: '',
          baseMoney:'',
          partnerType:'',
          address:'',
          site:'',
          email:'',
          companyName:'',
          corporateRepresentative:'',
          ratepayerNo:'',
          eCommerce:'',
          companyCode:'',
          businessLicense:'',
          email:'',
          partnerRemark: '',
          openBank:'',
          bankId:'',
          balance:'',
          phone:'',
          partnerRemark: '',
          saleCreditLine:'',
          // tissueId:'',
          // tissueName:'',
        },
        list: [
          { type: 'select区域：', label: '区域：', value: 'partnerArea', style: 'width:95%', className: 'form_item_three', required: true , list: 'areaList',disabled:true},
          { type: 'select往来单位类型：', label: '往来单位类型：', value: 'partnerGroup', style: 'width:95%', className: 'form_item_three', required: true, list: 'unitActionList',disabled:true},
          { type: 'text', label: '往来单位编码：', value: 'partnerCode', style: 'width:80%', className: 'form_item_three', required: true,disabled:true},
          { type: 'text', label: '客户：', value: 'partnerName', style: 'width:95%', className: 'form_item_three',disabled:true},
          { type: 'select性质：', label: '性质：', value: 'partnerType', style: 'width:95%', className: 'form_item_three', list: 'partnerType',disabled:true},
          { type: 'text', label: '电话号码：', value: 'phone', style: 'width:80%', className: 'form_item_three', required: true,disabled:true},
          { type: 'text', label: '地点：', value: 'site', style: 'width:95%', className: 'form_item_three',disabled:true},
          { type: 'text', label: '邮箱：', value: 'email', style: 'width:95%', className: 'form_item_three',disabled:true},
          { type: 'text', label: '客户地址电话:', value: 'address', style: 'width:80%', className: 'form_item_three',disabled:true},
          { type: 'text', label: '开户银行：', value: 'openBank', style: 'width:95%', className: 'form_item_three', required: true,disabled:true},
          { type: 'text', label: '银行账号：', value: 'bankId', style: 'width:95%', className: 'form_item_three', required: true,disabled:true},
          { type: 'text', label: '余额：', value: 'balance', style: 'width:80%', className: 'form_item_three',disabled:true},
          { type: 'text', label: '公司税号：', value: 'companyCode', style: 'width:95%', className: 'form_item_three',disabled:true},
          { type: 'text', label: '法人代表：', value: 'corporateRepresentative', style: 'width:95%', className: 'form_item_three',disabled:true},
          { type: 'text', label: '公司名称：', value: 'companyName', style: 'width:80%', className: 'form_item_three',disabled:true},
          { type: 'text', label: '纳税号：', value: 'ratepayerNo', style: 'width:95%', className: 'form_item_three',disabled:true},
          { type: 'text', label: '电商账号：', value: 'eCommerce', style: 'width:95%', className: 'form_item_three',disabled:true},
          { type: 'text', label: '授信额度：', value: 'saleCreditLine', style: 'width:80%', className: 'form_item_three',disabled:true},
          // { type: '', label: '营业执照：', value: '', style: 'width:95%', className: 'form_item_three',disabled:true},
          { type: 'text', label: '备注：', value: 'partnerRemark', style: 'width:95%', className: 'form_item_three',disabled:true},
        ],
        rules: {
        }
      }
    };
  },
  created () {
    const leftBtn = this.buttonList.left
    leftBtn.push({ icon: "el-icon-back", style: "background:#fff;color:#666;border:1px solid #666;margin-right:15px", desc: "返回", event: "back" })
    // leftBtn.push({ icon: "el-icon-check", style: "background:#1a7bb9", desc: "保存", event: "create" })
    // leftBtn.push({ icon: "el-icon-refresh-left", style: "background:#fff;color:#666;border:1px solid #666;margin-left:15px", desc: "重置", event: "reset" })
  },
  mounted () {
    this.$api.Customer.getBasePartnerPage({pageSize:9999,pageNum:1}).then(res => {//,forbidStatus:0
        if(res.code == 0) {
          for (let inf of res.data.list) {
            this.listTypeInfo.partnerId.push({value:inf.partnerId,label:inf.partnerName})
          }
        } else {
          this.$message( { message: res.msg, type: 'error'})
        }
    })
    this.$api.Material.getBaseMaterialPage({pageNum:1,pageSize:999}).then(res => {
      if (res.code == 0) {
        for (let inde of res.data.list) {
          this.listTypeInfo.materialId.push({value:inde.materialId,label:inde.materialName})
        }
      }else{
        this.$message({ message: res.msg, type: 'error' })
      }
    })
    // if (localStorage.loginTissueId) {
    //   this.$api.organization.getSysTissuePage({pageNum: 1, pageSize: 999}).then(res => {//组织
    //       if(res.code == 0) {
    //           this.listTypeInfo.tissueId = []
    //           let list3 = res.data.list
    //           for( let i in list3) {
    //             if (list3[i].id == localStorage.loginTissueId) {
    //               this.listTypeInfo.tissueId.push({value: list3[i].id, label: list3[i].tissueName})
    //             }
    //           }
    //       }
    //   })
    // } else {
    //   this.$api.organization.getSysTissuePage({pageNum: 1, pageSize: 999}).then(res => {//组织
    //       if(res.code == 0) {
    //           this.listTypeInfo.tissueId = []
    //           let list3 = res.data.list
    //           for( let i in list3 ) {
    //               this.listTypeInfo.tissueId.push({value: parseInt(list3[i].id), label: list3[i].tissueName})
    //           }
    //       }
    //   })
    // }
    this.init();
    this.Customer2();//单位常用联系人列表数据
    this.Customer4();//单位运输车辆表列表数据
    this.Customer5();//单位常用地址表列表数据
  },
  methods: {
    handlePictureCardPreview(businessLicense) {
      this.dialogImageUrl = businessLicense
      this.dialogVisible = true
    },
    // 初始化
    init () {
      this.departmentListPromise()
      this.$api.Region.getBaseAreaPage({pageNum: 1,pageSize: 999}).then(res => {
        if (res.code == 0) {
          let list = res.data.list
          for(let i in list){
            this.listTypeInfo.areaList.push({ value: list[i].areaId, label: list[i].areaName})
          }
        }
      })
      let date = JSON.parse(localStorage.CusInformation)
      for (let inde in date) {
        if (inde in this.formInfoDetailCus.data) {
          this.formInfoDetailCus.data[inde] = date[inde]
        }
      }
    },
    departmentListPromise () {
      var that = this
      return new Promise(function (resolve, reject) {
        that.$api.Customer.getBasePartnerGroupPage({pageNum: 1, pageSize: 9999}).then(res => {
          resolve(true)
          if (res.code == 0) {
            let data = []
            for (let i in res.data.list) {
              data.push({ label: res.data.list[i].groupName, value: res.data.list[i].groupId })
            }
            that.listTypeInfo.unitActionList = data
          } else {
            that.$message({ message: res.msg, type: 'error' })
          }
        }, err => {
          console.log(err)
          resolve(false)
        })
      })
    },
    Customer2(){//单位常用联系人列表
      this.$api.Customer.getBasePartnerContactPage({pageNum:1,pageSize:999,partnerId:localStorage.partnerId,tissueId:parseInt(localStorage.loginTissueId)}).then(res => {
        if (res.code == 0) {
          this.tableData2 = res.data.list
        } else {
          this.$message( { message: '往来单位常用联系人:'+res.msg, type: 'error'})
        }
      })
    },
    Customer4(){//单位运输车辆表列表
      this.$api.Customer.getBasePartnerWxCarPage({pageNum:1,pageSize:999,partnerId:localStorage.partnerId,tissueId:parseInt(localStorage.loginTissueId)}).then(res => {
        if (res.code == 0) {
          this.tableData4 = res.data.list
        } else {
          this.$message( { message: '往来单位运输车辆:'+res.msg, type: 'error'})
        }
      })
    },
    Customer5(){//单位常用地址列表
      this.$api.Customer.getBasePartnerAddressPage({pageNum:1,pageSize:999,partnerId:localStorage.partnerId,tissueId:parseInt(localStorage.loginTissueId)}).then(res => {
        if (res.code == 0) {
          this.tableData5 = res.data.list
        } else {
          this.$message( { message: '往来单位常用地址:'+res.msg, type: 'error'})
        }
      })
    },
    handleClick(tab, event) {//标签点击事件
      // console.log(tab.name,tab.label);
    },
    addRow (index, rows) {
      //判断标签 添加到哪个表格
      let bb = {}
      if (this.activeName == '1') {
        bb = {employeeId:'',certName:'',certNumber:this.tableData1.length+1,certTime:'',certImage:'',remark:'',addIndex:0}
      } else if (this.activeName == '2') {
        bb = {employeeId:'',guardian:'',named:'',birthDate:'',addressContact:'',phoneContact:'',remark:''}
      } else if (this.activeName == '3') {
        bb = {employeeId:'',graduateSchool:'',specialities:'',schoolExp:'',graduateTime:'',remark:''}
      } else if (this.activeName == '4') {
        bb = {employeeId:'',employeeName:'',bankAccount:'',bankName:'',openBank:'',phone:'',remark:''}
      } else if (this.activeName == '5') {
        bb = {employeeId:'',entryTime:'',jobContent:'',leaveTime:'',leavenReason:'',position:'',workCompany:'',remark:''}
      } else if (this.activeName == '6') {
        bb = {partnerId:'',totalRebate:'',totalRecharge:'',totalSend:'',baseMoney:'',auditStatus:0,remark:''}
      }
      rows.push(bb)
      for (let d in rows) {
        rows[d].addIndex = d
      }
    },
    // 表格头部按钮相关事件
    handClick (event, data) {
      switch (event) {
        case "create":
          if(this.activeName == 2){
            this.formInfo2.ref.validate((val) => {//调保存接口前先校验必传项是否为空
              if (val) {
                for (let ind3 of this.listTypeInfo.tissueId) {
                  if (this.formInfo2.data.tissueId == ind3.value) {
                    this.formInfo2.data.tissueName = ind3.label
                  }
                }
                for (let ind1 of this.listTypeInfo.partnerId) {
                  if (this.formInfo2.data.partnerId == ind1.value) {
                    this.formInfo2.data.partnerName = ind1.label
                  }
                }
                this.$api.Customer.saveBasePartnerContact(this.formInfo2.data).then(res => {//保存
                  if (res.code === 0) {
                    this.$message({ message: res.msg, type: 'success' })
                    this.Customer2()
                  } else {
                    this.$message({ message: res.msg, type: 'error' })
                  }
                })
              }
            })
          } else if(this.activeName == 3){
            this.formInfo3.ref.validate((val) => {//调保存接口前先校验必传项是否为空
              if (val) {
                for (let ind3 of this.listTypeInfo.tissueId) {
                  if (this.formInfo3.data.tissueId == ind3.value) {
                    this.formInfo3.data.tissueName = ind3.label
                  }
                }
                for (let ind1 of this.listTypeInfo.partnerId) {
                  if (this.formInfo3.data.partnerId == ind1.value) {
                    this.formInfo3.data.partnerName = ind1.label
                  }
                }
                this.$api.Customer.saveBasePartnerCar(this.formInfo3.data).then(res => {//保存
                  if (res.code === 0) {
                    this.$message({ message: res.msg, type: 'success' })
                    this.Customer3()
                  } else {
                    this.$message({ message: res.msg, type: 'error' })
                  }
                })
              }
            })
          } else if(this.activeName == 4){
            this.formInfo4.ref.validate((val) => {//调保存接口前先校验必传项是否为空
              if (val) {
                for (let ind3 of this.listTypeInfo.tissueId) {
                  if (this.formInfo4.data.tissueId == ind3.value) {
                    this.formInfo4.data.tissueName = ind3.label
                  }
                }
                for (let ind3 of this.listTypeInfo.tissueId) {
                  if (this.formInfo4.data.tissueId == ind3.value) {
                    this.formInfo4.data.tissueName = ind3.label
                  }
                }
                this.$api.Customer.saveBasePartnerWxCar(this.formInfo4.data).then(res => {//保存
                  if (res.code === 0) {
                    this.$message({ message: res.msg, type: 'success' })
                    this.Customer4()
                  } else {
                    this.$message({ message: res.msg, type: 'error' })
                  }
                })
              }
            })
          } else if(this.activeName == 5){
            this.formInfo5.ref.validate((val) => {//调保存接口前先校验必传项是否为空
              if (val) {
                for (let ind3 of this.listTypeInfo.tissueId) {
                  if (this.formInfo5.data.tissueId == ind3.value) {
                    this.formInfo5.data.tissueName = ind3.label
                  }
                }
                for (let ind1 of this.listTypeInfo.partnerId) {
                  if (this.formInfo5.data.partnerId == ind1.value) {
                    this.formInfo5.data.partnerName = ind1.label
                  }
                }
                this.$api.Customer.saveBasePartnerAddress(this.formInfo5.data).then(res => {//保存
                  if (res.code === 0) {
                    this.$message({ message: res.msg, type: 'success' })
                    this.Customer5()
                  } else {
                    this.$message({ message: res.msg, type: 'error' })
                  }
                })
              }
            })
          } else if(this.activeName == 6){
            this.$message({ message: '客户余额仅供查看', type: '' })
          }
          break;
        case "back":
          this.$router.push('/index/system/CustomerUnit')//返回单位
          break;
        case 'reset':
          if (this.activeName == 1) {
            for (let index1 in this.formInfo1.data) {
              if (index1 != 'partnerId' && index1 != 'tissueId') {
                this.formInfo1.data[index1] = ''
              }
            }
          }else if (this.activeName == 2) {
            for (let index1 in this.formInfo2.data) {
              if (index1 != 'partnerId' && index1 != 'tissueId') {
                this.formInfo2.data[index1] = ''
              }
            }
          }else if (this.activeName == 3) {
            for (let index1 in this.formInfo3.data) {
              if (index1 != 'partnerId' && index1 != 'tissueId') {
                this.formInfo3.data[index1] = ''
              }
            }
          }else if (this.activeName == 4) {
            for (let index1 in this.formInfo4.data) {
              if (index1 != 'partnerId' && index1 != 'tissueId') {
                this.formInfo4.data[index1] = ''
              }
            }
          }else if (this.activeName == 5) {
            for (let index1 in this.formInfo5.data) {
              if (index1 != 'partnerId' && index1 != 'tissueId') {
                this.formInfo5.data[index1] = ''
              }
            }
          }
          break
      }
    },
    rowClick (data) {
    },
    deleteRow(row,table){
      this.$confirm('确认删除选中记录吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$api.Customer.deleteBasePartnerContacts({ids:[row.id]}).then(res => {//保存
          if (res.code === 0) {
            this.$message({ message: res.msg, type: 'success' })
            this.Customer2()
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        })
      }).catch(() => {});
    }
  }
};
</script>
<style lang="stylus" scoped>
.avatar-uploader .el-upload
  border 1px dashed #d9d9d9
  border-radius 6px
  cursor pointer
  position relative
  overflow hidden
.avatar-uploader .el-upload:hover
  border-color #409EFF
.avatar-uploader-icon
  font-size 28px
  color #8c939d
  width 178px
  height 178px
  line-height 178px
  text-align center
  border 1px dashed #d5d5d5
.avatar
  width 178px
  height 178px
  display block
</style>



// WEBPACK FOOTER //
// src/views/pages/System/CusInformation.vue